import React, { useEffect } from "react";
import "./styles.scss";
import { NewsCard, NewsGroup, TrendingNewsCard } from "../../../components";
import { withRouter } from "react-router-dom";
// import { getNewsByCategoryPage } from "../../news/service/news.service";
// import { getCategoryById } from "../../CreateNewItem/CreateNewCategory/service/category.service";
import { getLanguage } from "../../../utils/environment";
import { useDispatch, useSelector } from "react-redux";
import { setNewsList } from "../../news/redux/actions";
import { getTrendingNewsByCategory } from "../../newsViewPage/service/news.service";
import moment from "moment";

const categoryId = process.env.REACT_APP_CABINET_NEWS;
const pageCount = process.env.REACT_APP_P_COUNT;
const lan = getLanguage();

const Index = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [news, setNews] = React.useState([]);
  const [menu, setMenu] = React.useState("");
  const dispatch = useDispatch();

  // const newsList = useSelector((state) => state.newsReducer.newsList);

  const type = "monthly";
  const period = moment().format("MM");
  const year = moment().format("YYYY");
  const language = getLanguage();
  const noOfNews = "5";

  useEffect(() => {
    async function fetchPageData() {
      try {
        const getNews = await getTrendingNewsByCategory(
          type,
          period,
          year,
          language,
          noOfNews
        );
        console.log("GetTrendingNews", getNews);

        if (getNews?.data) {
          // dispatch(setNewsList(getNews?.data));
          setNews(getNews?.data?.trending_news);
        } else {
          console.error("No data found for trending news");
        }
      } catch (error) {
        console.error("Error fetching page data:", error);
      }
    }

    if (props.active && news?.length === 0) {
      fetchPageData();
    }
  }, [props.active]);

  return (
    <>
      <NewsGroup
        data={{
          titleName: "Trending news",
          type: "en",
          linkName: "",
        }}
        // onClickViewNews={() => {
        //   props.history.push("/" + categoryId);
        //   props.setMenuName(categoryId);
        // }}
      >
        {Array.isArray(news) && news.length > 0 ? (
          news.map((data, index) => (
            <TrendingNewsCard
              data={{
                isBorder: index + 1 < news.length,
                isTrendingNo: true,
                trendingNo: index + 1,
                isDate: false,
                img_url: data?.images?.[0]?.url,
                header: data?.title[language],
                content: data?.content,
                createAt: data?.created_at,
                publish_date: data?.created_at,
                tagViews: data?.views,
              }}
              onClick={() => {
                if (data?.keywords?.[lan]) {
                  props.history.push(
                    `/${data?.keywords?.[lan]}/${data?.news_id}`
                  );
                } else {
                  const generatedSlug = data?.title?.[language]
                    ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                    ?.replace(/\//g, "")
                    ?.replace(/\s*-\s*/g, " ")
                    ?.trim()
                    .split(/\s+/)
                    .slice(0, 5)
                    .join("-")
                    .replace(/-+/g, "-");
                  props.history.push(`/${generatedSlug}/${data?.news_id}`);
                }
              }}
              // onClick={() => {}}
            />
          ))
        ) : (
          <div className="d-flex justify-content-center align-items-center">
            <h6 className="text-muted">No Trending News Available</h6>
          </div>
        )}

        {/* <TrendingNewsCard
          data={{
            isBorder: true,
            isTrendingNo: true,
            trendingNo: "2",
            isDate: false,
            header: "මහ බැංකුව පොලී අඩු කරයි.",
            content: "හිටපු ජනපතිවරුන්ගේ විදෙස් සංචාර සඳහා වැය වූ...",
          }}
          // onClick={() => {}}
        />
        <TrendingNewsCard
          data={{
            isBorder: true,
            isTrendingNo: true,
            trendingNo: "3",
            isDate: false,
            header: "මහ බැංකුව පොලී අඩු කරයි.",
            content: "හිටපු ජනපතිවරුන්ගේ විදෙස් සංචාර සඳහා වැය වූ...",
          }}
          // onClick={() => {}}
        /> */}
      </NewsGroup>
    </>
  );
};
export default withRouter(Index);
// export default Index;
